/* Mr Pixel — controller overlay (HUD). */
(function () {
  'use strict';

  function psGlyph(inner) {
    return (
      '<svg class="mp-ctl-chip__glyph" viewBox="0 0 20 20" aria-hidden="true" focusable="false">' +
      inner +
      '</svg>'
    );
  }

  var PS_SHAPES = {
    cross:
      '<path d="M6 6 L14 14 M14 6 L6 14" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/>',
    circle:
      '<circle cx="10" cy="10" r="4.6" fill="none" stroke="currentColor" stroke-width="2.2"/>',
    square:
      '<rect x="5.8" y="5.8" width="8.4" height="8.4" rx="1.2" fill="none" stroke="currentColor" stroke-width="2.2"/>',
    triangle:
      '<path d="M10 5 L15.4 14.6 L4.6 14.6 Z" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linejoin="round"/>'
  };

  var PACKS = {
    xbox360: {
      label: 'Xbox 360',
      stick: 'analog',
      travel: 4,

      overlay:
        '<svg class="mp-ctl__svg" viewBox="0 0 1000 616" aria-hidden="true" focusable="false">' +

          '<defs>' +
            '<radialGradient id="mpCap360" cx="50%" cy="32%" r="66%">' +
              '<stop offset="0%" stop-color="#63666c"/>' +
              '<stop offset="52%" stop-color="#3d3f43"/>' +
              '<stop offset="100%" stop-color="#212326"/>' +
            '</radialGradient>' +
            '<radialGradient id="mpDish360" cx="50%" cy="38%" r="62%">' +
              '<stop offset="0%" stop-color="#2b2d31"/>' +
              '<stop offset="100%" stop-color="#3a3c40"/>' +
            '</radialGradient>' +
            '<radialGradient id="mpWell360" cx="50%" cy="40%" r="62%">' +
              '<stop offset="0%" stop-color="#0d0e10"/>' +
              '<stop offset="100%" stop-color="#1c1e21"/>' +
            '</radialGradient>' +
          '</defs>' +

          '<circle class="mp-ctl__photo-well" cx="189" cy="185" r="70" fill="url(#mpWell360)"/>' +
          '<g class="mp-ctl__cap" data-mp-ctl-cap>' +
            '<circle cx="189" cy="185" r="51" fill="url(#mpCap360)"/>' +
            '<circle cx="189" cy="185" r="33" fill="url(#mpDish360)"/>' +
          '</g>' +
          '<circle class="mp-ctl__photo-well" cx="644" cy="340" r="70" fill="url(#mpWell360)"/>' +
          '<g class="mp-ctl__cap" data-mp-ctl-cap-r>' +
            '<circle cx="644" cy="340" r="51" fill="url(#mpCap360)"/>' +
            '<circle cx="644" cy="340" r="33" fill="url(#mpDish360)"/>' +
          '</g>' +

          '<path class="mp-ctl__ring" d="M443 184 A58 58 0 0 1 501 126"/>' +

          '<g class="mp-ctl__face mp-ctl__face--y" data-mp-ctl-face="y">' +
            '<circle class="mp-ctl__btn" cx="805" cy="107" r="31"/>' +
            '<text class="mp-ctl__glyph" x="805" y="107">Y</text></g>' +
          '<g class="mp-ctl__face mp-ctl__face--x" data-mp-ctl-face="x">' +
            '<circle class="mp-ctl__btn" cx="735" cy="181" r="31"/>' +
            '<text class="mp-ctl__glyph" x="735" y="181">X</text></g>' +
          '<g class="mp-ctl__face mp-ctl__face--b" data-mp-ctl-face="b">' +
            '<circle class="mp-ctl__btn" cx="874" cy="181" r="31"/>' +
            '<text class="mp-ctl__glyph" x="874" y="181">B</text></g>' +
          '<g class="mp-ctl__face mp-ctl__face--a" data-mp-ctl-face="a">' +
            '<circle class="mp-ctl__btn" cx="804" cy="253" r="31"/>' +
            '<text class="mp-ctl__glyph" x="804" y="253">A</text></g>' +
        '</svg>',

      photoTravel: 17,
      glyphs: { a: 'A', b: 'B', x: 'X', y: 'Y' },
      verbs: { a: 'Select', b: 'Back', x: 'Search', y: 'More' },
      svg:
        '<svg class="mp-ctl__svg" viewBox="0 0 154 105" aria-hidden="true" focusable="false">' +

          '<path class="mp-ctl__bumper mp-ctl__paint" d="M30 8.5 C42 6 56 4.8 68 4.3"/>' +
          '<path class="mp-ctl__bumper mp-ctl__paint" d="M124 8.5 C112 6 98 4.8 86 4.3"/>' +

          '<path class="mp-ctl__body mp-ctl__paint" d="M77 9 C96 9 112 10 124 13 C137 18 147 30 151 46 ' +
            'C155 62 153 80 145 93 C138 102 126 104 117 98 C109 92 105 83 100 73 ' +
            'C96 67 90 65 87 65 L67 65 C64 65 58 67 54 73 C49 83 45 92 37 98 ' +
            'C28 104 16 102 9 93 C1 80 -1 62 3 46 C7 30 17 18 30 13 C42 10 58 9 77 9 Z"/>' +
          '<ellipse class="mp-ctl__plate mp-ctl__paint" cx="77" cy="38" rx="54" ry="26"/>' +

          '<circle class="mp-ctl__guide-well" cx="77" cy="28" r="12"/>' +
          '<circle class="mp-ctl__ring-dim mp-ctl__ring-track" cx="77" cy="28" r="9.5"/>' +
          '<path class="mp-ctl__ring" d="M67.5 28 A9.5 9.5 0 0 1 77 18.5"/>' +
          '<circle class="mp-ctl__minor mp-ctl__paint" cx="60" cy="41" r="3"/>' +
          '<circle class="mp-ctl__minor mp-ctl__paint" cx="94" cy="41" r="3"/>' +

          '<circle class="mp-ctl__well" cx="40" cy="33" r="13"/>' +
          '<g class="mp-ctl__cap" data-mp-ctl-cap>' +
            '<circle class="mp-ctl__cap-body" cx="40" cy="33" r="9"/>' +
            '<circle class="mp-ctl__cap-dish" cx="40" cy="33" r="5.6"/>' +
          '</g>' +
          '<path class="mp-ctl__dpad mp-ctl__paint" d="M48.5 49 h11 v5.5 h5.5 v11 h-5.5 v5.5 h-11 v-5.5 h-5.5 v-11 h5.5 Z"/>' +
          '<circle class="mp-ctl__well" cx="95" cy="57" r="12"/>' +
          '<g class="mp-ctl__cap" data-mp-ctl-cap-r>' +
            '<circle class="mp-ctl__cap-body" cx="95" cy="57" r="8.4"/>' +
            '<circle class="mp-ctl__cap-dish" cx="95" cy="57" r="5.2"/>' +
          '</g>' +

          '<g class="mp-ctl__face mp-ctl__face--y" data-mp-ctl-face="y">' +
            '<circle class="mp-ctl__btn" cx="116" cy="19" r="6"/>' +
            '<text class="mp-ctl__glyph" x="116" y="19">Y</text></g>' +
          '<g class="mp-ctl__face mp-ctl__face--x" data-mp-ctl-face="x">' +
            '<circle class="mp-ctl__btn" cx="101" cy="34" r="6"/>' +
            '<text class="mp-ctl__glyph" x="101" y="34">X</text></g>' +
          '<g class="mp-ctl__face mp-ctl__face--b" data-mp-ctl-face="b">' +
            '<circle class="mp-ctl__btn" cx="131" cy="34" r="6"/>' +
            '<text class="mp-ctl__glyph" x="131" y="34">B</text></g>' +
          '<g class="mp-ctl__face mp-ctl__face--a" data-mp-ctl-face="a">' +
            '<circle class="mp-ctl__btn" cx="116" cy="49" r="6"/>' +
            '<text class="mp-ctl__glyph" x="116" y="49">A</text></g>' +
        '</svg>'
    },

    ps3: {
      label: 'PlayStation 3',
      stick: 'analog',
      travel: 4,
      overlay:
        '<svg class="mp-ctl__svg" viewBox="0 0 1000 611" aria-hidden="true" focusable="false">' +
          '<defs>' +
            '<radialGradient id="mpCapPs3" cx="50%" cy="30%" r="68%">' +
              '<stop offset="0%" stop-color="#585c61"/>' +
              '<stop offset="55%" stop-color="#43464a"/>' +
              '<stop offset="100%" stop-color="#2a2c2f"/>' +
            '</radialGradient>' +
            '<radialGradient id="mpDishPs3" cx="50%" cy="36%" r="64%">' +
              '<stop offset="0%" stop-color="#4c5054"/>' +
              '<stop offset="100%" stop-color="#35383c"/>' +
            '</radialGradient>' +
            '<radialGradient id="mpWellPs3" cx="50%" cy="40%" r="62%">' +
              '<stop offset="0%" stop-color="#0f1012"/>' +
              '<stop offset="100%" stop-color="#1b1d1f"/>' +
            '</radialGradient>' +
          '</defs>' +
          '<circle class="mp-ctl__photo-well" cx="346" cy="380" r="100" fill="url(#mpWellPs3)"/>' +
          '<g class="mp-ctl__cap" data-mp-ctl-cap>' +
            '<circle cx="346" cy="380" r="80" fill="url(#mpCapPs3)"/>' +
            '<circle cx="346" cy="380" r="49" fill="url(#mpDishPs3)"/>' +
          '</g>' +
          '<circle class="mp-ctl__photo-well" cx="658" cy="384" r="100" fill="url(#mpWellPs3)"/>' +
          '<g class="mp-ctl__cap" data-mp-ctl-cap-r>' +
            '<circle cx="658" cy="384" r="80" fill="url(#mpCapPs3)"/>' +
            '<circle cx="658" cy="384" r="49" fill="url(#mpDishPs3)"/>' +
          '</g>' +

          '<g class="mp-ctl__face mp-ctl__face--y" data-mp-ctl-face="y">' +
            '<circle class="mp-ctl__btn" cx="808" cy="161" r="35"/>' +
            '<path class="mp-ctl__glyph-path mp-ctl__glyph-path--open" d="M808 145 L825 175 L791 175 Z"/></g>' +
          '<g class="mp-ctl__face mp-ctl__face--x" data-mp-ctl-face="x">' +
            '<circle class="mp-ctl__btn" cx="729" cy="237" r="35"/>' +
            '<rect class="mp-ctl__glyph-path mp-ctl__glyph-path--open" x="715" y="223" width="28" height="28" rx="4"/></g>' +
          '<g class="mp-ctl__face mp-ctl__face--b" data-mp-ctl-face="b">' +
            '<circle class="mp-ctl__btn" cx="892" cy="237" r="35"/>' +
            '<circle class="mp-ctl__glyph-path mp-ctl__glyph-path--open" cx="892" cy="237" r="14"/></g>' +
          '<g class="mp-ctl__face mp-ctl__face--a" data-mp-ctl-face="a">' +
            '<circle class="mp-ctl__btn" cx="809" cy="308" r="35"/>' +
            '<path class="mp-ctl__glyph-path mp-ctl__glyph-path--open" d="M795 294 l28 28 M823 294 l-28 28"/></g>' +
        '</svg>',

      photoTravel: 16,
      glyphs: {
        a: psGlyph(PS_SHAPES.cross),
        b: psGlyph(PS_SHAPES.circle),
        x: psGlyph(PS_SHAPES.square),
        y: psGlyph(PS_SHAPES.triangle)
      },
      verbs: { a: 'Select', b: 'Back', x: 'Search', y: 'More' },
      svg:
        '<svg class="mp-ctl__svg" viewBox="0 0 160 97" aria-hidden="true" focusable="false">' +

          '<path class="mp-ctl__bumper mp-ctl__paint" d="M28 11 C38 8 50 6 62 5.5"/>' +
          '<path class="mp-ctl__bumper mp-ctl__paint" d="M132 11 C122 8 110 6 98 5.5"/>' +

          '<path class="mp-ctl__body mp-ctl__paint" d="M80 10 C100 10 116 11 132 16 C143 22 150 34 154 52 ' +
            'C158 68 155 84 147 93 C141 98 132 97 126 90 C118 83 110 74 100 68 ' +
            'C96 66 92 66 88 66 L72 66 C68 66 64 66 60 68 C50 74 42 83 34 90 ' +
            'C28 97 19 98 13 93 C5 84 2 68 6 52 C10 34 17 22 28 16 C44 11 60 10 80 10 Z"/>' +
          '<ellipse class="mp-ctl__plate mp-ctl__paint" cx="80" cy="38" rx="58" ry="26"/>' +
          '<path class="mp-ctl__dpad mp-ctl__paint" d="M28.5 20 h13 v6.5 h6.5 v13 h-6.5 v6.5 h-13 v-6.5 h-6.5 v-13 h6.5 Z"/>' +
          '<rect class="mp-ctl__minor mp-ctl__paint" x="61" y="35" width="10" height="4" rx="2"/>' +
          '<rect class="mp-ctl__minor mp-ctl__paint" x="89" y="35" width="10" height="4" rx="2"/>' +

          '<circle class="mp-ctl__well" cx="56" cy="55" r="14"/>' +
          '<g class="mp-ctl__cap" data-mp-ctl-cap>' +
            '<circle class="mp-ctl__cap-body" cx="56" cy="55" r="10"/>' +
            '<circle class="mp-ctl__cap-dish" cx="56" cy="55" r="6"/>' +
          '</g>' +
          '<circle class="mp-ctl__well" cx="104" cy="55" r="14"/>' +
          '<g class="mp-ctl__cap" data-mp-ctl-cap-r>' +
            '<circle class="mp-ctl__cap-body" cx="104" cy="55" r="10"/>' +
            '<circle class="mp-ctl__cap-dish" cx="104" cy="55" r="6"/>' +
          '</g>' +
          '<circle class="mp-ctl__ring-dim mp-ctl__ring-track" cx="80" cy="58" r="5.5"/>' +
          '<circle class="mp-ctl__ring" cx="80" cy="58" r="3"/>' +

          '<g class="mp-ctl__face mp-ctl__face--y" data-mp-ctl-face="y">' +
            '<circle class="mp-ctl__btn" cx="125" cy="21" r="6.5"/>' +
            '<path class="mp-ctl__glyph-path mp-ctl__glyph-path--open" d="M125 17.4 L128.7 23.8 L121.3 23.8 Z"/></g>' +
          '<g class="mp-ctl__face mp-ctl__face--x" data-mp-ctl-face="x">' +
            '<circle class="mp-ctl__btn" cx="111" cy="35" r="6.5"/>' +
            '<rect class="mp-ctl__glyph-path mp-ctl__glyph-path--open" x="107.6" y="31.6" width="6.8" height="6.8" rx="1"/></g>' +
          '<g class="mp-ctl__face mp-ctl__face--b" data-mp-ctl-face="b">' +
            '<circle class="mp-ctl__btn" cx="139" cy="35" r="6.5"/>' +
            '<circle class="mp-ctl__glyph-path mp-ctl__glyph-path--open" cx="139" cy="35" r="3.3"/></g>' +
          '<g class="mp-ctl__face mp-ctl__face--a" data-mp-ctl-face="a">' +
            '<circle class="mp-ctl__btn" cx="125" cy="49" r="6.5"/>' +
            '<path class="mp-ctl__glyph-path mp-ctl__glyph-path--open" d="M121.6 45.6 l6.8 6.8 M128.4 45.6 l-6.8 6.8"/></g>' +
        '</svg>'
    },

    wii: {
      label: 'Wii',
      stick: 'dpad',
      travel: 1.6,
      overlay:
        '<svg class="mp-ctl__svg" viewBox="0 0 1000 3561" aria-hidden="true" focusable="false">' +

          '<g class="mp-ctl__cap mp-ctl__cap--dpad" data-mp-ctl-cap>' +
            '<rect class="mp-ctl__dpad-dir mp-ctl__dpad-dir--up" x="408" y="334" width="200" height="180" rx="26"/>' +
            '<rect class="mp-ctl__dpad-dir mp-ctl__dpad-dir--down" x="408" y="684" width="200" height="180" rx="26"/>' +
            '<rect class="mp-ctl__dpad-dir mp-ctl__dpad-dir--left" x="238" y="504" width="180" height="190" rx="26"/>' +
            '<rect class="mp-ctl__dpad-dir mp-ctl__dpad-dir--right" x="598" y="504" width="180" height="190" rx="26"/>' +
          '</g>' +

          '<g class="mp-ctl__face mp-ctl__face--a" data-mp-ctl-face="a">' +
            '<circle class="mp-ctl__btn" cx="498" cy="1202" r="167"/>' +
            '<text class="mp-ctl__glyph" x="498" y="1202">A</text></g>' +
          '<g class="mp-ctl__face mp-ctl__face--x" data-mp-ctl-face="x">' +
            '<circle class="mp-ctl__btn" cx="495" cy="2643" r="96"/>' +
            '<text class="mp-ctl__glyph" x="495" y="2643">1</text></g>' +
          '<g class="mp-ctl__face mp-ctl__face--y" data-mp-ctl-face="y">' +
            '<circle class="mp-ctl__btn" cx="498" cy="2925" r="96"/>' +
            '<text class="mp-ctl__glyph" x="498" y="2925">2</text></g>' +

          '<g class="mp-ctl__face mp-ctl__face--b mp-ctl__trigger" data-mp-ctl-face="b">' +
            '<rect class="mp-ctl__btn" x="0" y="1075" width="215" height="260" rx="70"/>' +
            '<text class="mp-ctl__glyph mp-ctl__glyph--trigger" x="107" y="1205">B</text></g>' +

          '<rect class="mp-ctl__ring" x="241" y="3135" width="54" height="54" rx="10"/>' +
        '</svg>',
      photoTravel: 0,
      glyphs: { a: 'A', b: 'B', x: '1', y: '2' },
      verbs: { a: 'Select', b: 'Back', x: 'Search', y: 'More' },
      svg:
        '<svg class="mp-ctl__svg" viewBox="0 0 68 204" aria-hidden="true" focusable="false">' +

          '<g class="mp-ctl__face mp-ctl__face--b mp-ctl__trigger" data-mp-ctl-face="b">' +
            '<path class="mp-ctl__btn" d="M17 66 C6 70 2 78 2 88 C2 98 6 106 17 110 Z"/>' +
            '<text class="mp-ctl__glyph mp-ctl__glyph--trigger" x="9" y="88">B</text></g>' +
          '<rect class="mp-ctl__body mp-ctl__paint" x="14" y="4" width="42" height="196" rx="11"/>' +
          '<circle class="mp-ctl__minor mp-ctl__paint" cx="35" cy="20" r="4"/>' +

          '<g class="mp-ctl__cap mp-ctl__cap--dpad" data-mp-ctl-cap>' +
            '<path class="mp-ctl__dpad" d="M30 34 h10 v10 h10 v10 h-10 v10 h-10 v-10 h-10 v-10 h10 Z"/>' +
            '<path class="mp-ctl__dpad-dir mp-ctl__dpad-dir--up" d="M30 34 h10 v10 h-10 Z"/>' +
            '<path class="mp-ctl__dpad-dir mp-ctl__dpad-dir--down" d="M30 54 h10 v10 h-10 Z"/>' +
            '<path class="mp-ctl__dpad-dir mp-ctl__dpad-dir--left" d="M20 44 h10 v10 h-10 Z"/>' +
            '<path class="mp-ctl__dpad-dir mp-ctl__dpad-dir--right" d="M40 44 h10 v10 h-10 Z"/>' +
          '</g>' +
          '<g class="mp-ctl__face mp-ctl__face--a" data-mp-ctl-face="a">' +
            '<circle class="mp-ctl__btn" cx="35" cy="86" r="10"/>' +
            '<text class="mp-ctl__glyph" x="35" y="86">A</text></g>' +
          '<rect class="mp-ctl__minor mp-ctl__paint" x="19" y="110" width="8" height="4" rx="2"/>' +
          '<circle class="mp-ctl__minor mp-ctl__paint" cx="35" cy="112" r="5"/>' +
          '<rect class="mp-ctl__minor mp-ctl__paint" x="43" y="110" width="8" height="4" rx="2"/>' +
          '<circle class="mp-ctl__hole mp-ctl__paint" cx="31" cy="130" r="1.2"/>' +
          '<circle class="mp-ctl__hole mp-ctl__paint" cx="35" cy="130" r="1.2"/>' +
          '<circle class="mp-ctl__hole mp-ctl__paint" cx="39" cy="130" r="1.2"/>' +
          '<circle class="mp-ctl__hole mp-ctl__paint" cx="31" cy="135" r="1.2"/>' +
          '<circle class="mp-ctl__hole mp-ctl__paint" cx="35" cy="135" r="1.2"/>' +
          '<circle class="mp-ctl__hole mp-ctl__paint" cx="39" cy="135" r="1.2"/>' +
          '<g class="mp-ctl__face mp-ctl__face--x" data-mp-ctl-face="x">' +
            '<circle class="mp-ctl__btn" cx="35" cy="150" r="7.5"/>' +
            '<text class="mp-ctl__glyph" x="35" y="150">1</text></g>' +
          '<g class="mp-ctl__face mp-ctl__face--y" data-mp-ctl-face="y">' +
            '<circle class="mp-ctl__btn" cx="35" cy="172" r="7.5"/>' +
            '<text class="mp-ctl__glyph" x="35" y="172">2</text></g>' +

          '<rect class="mp-ctl__ring" x="22" y="190" width="5" height="3.4" rx="1"/>' +
          '<rect class="mp-ctl__ring-dim" x="29" y="190" width="5" height="3.4" rx="1"/>' +
          '<rect class="mp-ctl__ring-dim" x="36" y="190" width="5" height="3.4" rx="1"/>' +
          '<rect class="mp-ctl__ring-dim" x="43" y="190" width="5" height="3.4" rx="1"/>' +
        '</svg>'
    }
  };

  var DEFAULT_PACK = 'xbox360';
  var STORE_KEY = 'mp-controller';

  var ROLES = [
    {
      btn: 'b',
      sel: [
        '[data-mp-btn="b"]',
        '[data-mp-to-top]',
        '[data-mp-to-top-inline]',
        '.mp-to-top',
        '.mp-to-top-inline',
        '.mp-breadcrumb a',
        '.breadcrumb a',
        '.drawer__close',
        '.cart-drawer__close',
        '.modal__close-button',
        '.search-modal__close-button',
        '[data-mp-gate-cancel]'
      ].join(',')
    },
    {
      btn: 'x',
      sel: [
        '[data-mp-btn="x"]',
        '.header__icon--search',
        '.search__button',
        '.search-modal__form button',
        'form[action$="/search"] button',
        '.facets__summary',
        '.facets__button',
        '.mp-search__input',
        'input[type="search"]'
      ].join(',')
    },
    {
      btn: 'y',
      sel: [
        '[data-mp-btn="y"]',
        '.mp-accordion summary',
        '.accordion summary',
        '.product__accordion summary'
      ].join(',')
    },
    {
      btn: 'a',
      sel: [
        '[data-mp-btn="a"]',
        'a[href]',
        'button',
        'summary',
        '[role="button"]',
        'input[type="submit"]',
        'label.facet-checkbox',
        '.card__heading a'
      ].join(',')
    }
  ];

  var EXCLUDE = [
    '.mp-ctl',
    '[data-mp-no-btn]',
    '[disabled]',
    '[aria-disabled="true"]',
    '.mp-age-gate__panel'
  ].join(',');

  var ANY = ROLES.map(function (r) { return r.sel; }).join(',');

  var FAST = 1.4;
  var SCROLL_FULL = 140;
  var DECAY = 0.86;
  var SPRING = 0.22;
  var DEADZONE = 0.14;
  var DPAD_ON = 0.35;
  var PRESS_MS = 170;

  function readPrefs(fallbackPack) {
    var prefs = { on: true, pack: PACKS[fallbackPack] ? fallbackPack : DEFAULT_PACK };
    try {
      var raw = window.localStorage.getItem(STORE_KEY);
      if (raw) {
        var saved = JSON.parse(raw);
        if (typeof saved.on === 'boolean') prefs.on = saved.on;
        if (saved.pack && PACKS[saved.pack]) prefs.pack = saved.pack;
      }
    } catch (e) {
    }
    return prefs;
  }

  function writePrefs(prefs) {
    try {
      window.localStorage.setItem(STORE_KEY, JSON.stringify(prefs));
    } catch (e) {
    }
  }

  function init() {
    var root = document.querySelector('[data-mp-ctl]');
    if (!root) return;

    if (document.documentElement.classList.contains('shopify-design-mode')) return;

    var fine = window.matchMedia('(min-width: 1024px) and (hover: hover) and (pointer: fine)');
    if (!fine.matches) {
      fine.addEventListener('change', function handler(e) {
        if (e.matches) {
          fine.removeEventListener('change', handler);
          init();
        }
      });
      return;
    }

    var prefs = readPrefs(root.getAttribute('data-default-pack'));

    var siteEnabled = root.getAttribute('data-mp-ctl-site') !== 'false';
    var productEnabled = root.getAttribute('data-mp-ctl-product') !== 'false';

    var dock = document.querySelector('[data-mp-ctl-dock]');
    var dockPack = dock ? dock.getAttribute('data-pack') : '';
    var docked = !!(dock && dockPack && PACKS[dockPack]) && productEnabled;

    if (!docked && !siteEnabled) return;

    var userPack = prefs.pack;

    var dockNeighbour = null;

    if (docked) {
      prefs.pack = dockPack;
      dock.appendChild(root);

      dock.classList.add('is-docked');
      root.classList.add('is-docked');

      var dockWrap = dock.closest('[data-mp-pad]');
      if (dockWrap) {
        var neighbourSel = dockWrap.getAttribute('data-mp-pad') === 'portrait'
          ? '.mp-extras__facts'
          : '.mp-extras__banner';
        dockNeighbour = dockWrap.querySelector(neighbourSel);
      }
    }

    var pad = root.querySelector('[data-mp-ctl-pad]');
    var toggle = root.querySelector('[data-mp-ctl-toggle]');
    var panel = root.querySelector('[data-mp-ctl-panel]');
    var packList = root.querySelector('[data-mp-ctl-packs]');
    var onSwitch = root.querySelector('[data-mp-ctl-on]');

    var pack = PACKS[prefs.pack] || PACKS[DEFAULT_PACK];
    var cap = null;
    var capR = null;
    var onPhoto = false;
    var faces = { a: null, b: null, x: null, y: null };
    var running = false;

    var lx = 0, ly = 0, ltx = 0, lty = 0;
    var rx = 0, ry = 0, rtx = 0, rty = 0;
    var lastMoveT = 0;
    var lastMx = 0, lastMy = 0;
    var mx = -200, my = -200;
    var lastScrollY = window.scrollY || 0;
    var hovered = null;
    var activeBtn = null;
    var padCount = 0;
    var gamepadLit = { a: false, b: false, x: false, y: false };
    var pressTimer = null;
    var wroteL = '';
    var wroteR = '';
    var wroteDir = '';

    function offset(ox, oy) {
      var t = (onPhoto && pack.photoTravel) ? pack.photoTravel : pack.travel;
      return 'translate(' + (ox * t).toFixed(2) + ' ' + (oy * t).toFixed(2) + ')';
    }

    function writeSticks() {
      if (cap) {
        var nl = offset(lx, ly);
        if (nl !== wroteL) {
          cap.setAttribute('transform', nl);
          wroteL = nl;
        }

        if (pack.stick === 'dpad') {
          var dir = '';
          if (Math.abs(lx) > Math.abs(ly)) {
            if (Math.abs(lx) > DPAD_ON) dir = lx > 0 ? 'right' : 'left';
          } else if (Math.abs(ly) > DPAD_ON) {
            dir = ly > 0 ? 'down' : 'up';
          }
          if (dir !== wroteDir) {
            wroteDir = dir;
            if (dir) cap.setAttribute('data-dir', dir);
            else cap.removeAttribute('data-dir');
          }
        }
      }

      if (capR) {
        var nr = offset(rx, ry);
        if (nr !== wroteR) {
          capR.setAttribute('transform', nr);
          wroteR = nr;
        }
      }
    }

    function applyPack() {
      root.setAttribute('data-pack', prefs.pack);

      var photo = pack.overlay ? root.getAttribute('data-photo-' + prefs.pack) : null;
      root.setAttribute('data-photo', photo ? 'on' : 'off');

      if (photo) {
        pad.innerHTML =
          '<span class="mp-ctl__photo">' +
          '<img class="mp-ctl__photo-img" src="' + encodeURI(photo) + '" alt="" aria-hidden="true">' +
          pack.overlay +
          '</span>';
      } else {
        pad.innerHTML = pack.svg;
      }
      onPhoto = !!photo;

      cap = pad.querySelector('[data-mp-ctl-cap]');
      capR = pad.querySelector('[data-mp-ctl-cap-r]');
      ['a', 'b', 'x', 'y'].forEach(function (k) {
        faces[k] = pad.querySelector('[data-mp-ctl-face="' + k + '"]');
      });

      wroteL = '';
      wroteR = '';
      wroteDir = '';
      writeSticks();
      lightFace(activeBtn, !!activeBtn);
    }

    function lightFace(btn, on) {
      ['a', 'b', 'x', 'y'].forEach(function (k) {
        if (!faces[k]) return;
        faces[k].classList.toggle('is-lit', (k === btn && on) || gamepadLit[k]);
      });
    }

    function clearActive() {
      activeBtn = null;
      lightFace(null, false);
    }

    function syncDockSize() {
      if (!docked || !dockNeighbour) return;
      var h = dockNeighbour.getBoundingClientRect().height;
      if (h > 0) root.style.setProperty('--mp-ctl-size', h + 'px');
    }

    function roleFor(el) {
      var override = el.closest('[data-mp-btn]');
      if (override && pack.glyphs[override.getAttribute('data-mp-btn')]) {
        return override.getAttribute('data-mp-btn');
      }
      for (var i = 0; i < ROLES.length; i++) {
        if (el.matches(ROLES[i].sel)) return ROLES[i].btn;
      }
      return 'a';
    }

    function hitFor(target) {
      if (!target || !target.closest) return null;
      var el = target.closest(ANY);
      if (!el) return null;
      if (el.closest(EXCLUDE)) return null;
      return el;
    }

    function readGamepad() {
      if (!padCount || !navigator.getGamepads) return false;
      var pads = navigator.getGamepads();
      for (var i = 0; i < pads.length; i++) {
        var gp = pads[i];
        if (!gp || !gp.connected) continue;

        ltx = dead(gp.axes[0]);
        lty = dead(gp.axes[1]);
        rtx = dead(gp.axes[2]);
        rty = dead(gp.axes[3]);

        var order = ['a', 'b', 'x', 'y'];
        var changed = false;
        for (var b = 0; b < 4; b++) {
          var pressed = !!(gp.buttons[b] && gp.buttons[b].pressed);
          if (gamepadLit[order[b]] !== pressed) {
            gamepadLit[order[b]] = pressed;
            changed = true;
          }
        }
        if (changed) lightFace(activeBtn, !!activeBtn);
        return true;
      }
      return false;
    }

    function frame() {
      var live = readGamepad();

      if (!live) {
        ltx = fade(ltx);
        lty = fade(lty);
        rtx = fade(rtx);
        rty = fade(rty);
      }

      lx += (ltx - lx) * SPRING;
      ly += (lty - ly) * SPRING;
      rx += (rtx - rx) * SPRING;
      ry += (rty - ry) * SPRING;

      var ml = Math.sqrt(lx * lx + ly * ly);
      if (ml > 1) { lx /= ml; ly /= ml; }
      var mr = Math.sqrt(rx * rx + ry * ry);
      if (mr > 1) { rx /= mr; ry /= mr; }

      writeSticks();

      var settled =
        Math.abs(lx) < 0.002 && Math.abs(ly) < 0.002 && !ltx && !lty &&
        Math.abs(rx) < 0.002 && Math.abs(ry) < 0.002 && !rtx && !rty;
      if (settled && !padCount) {
        running = false;
        return;
      }
      requestAnimationFrame(frame);
    }

    function start() {
      if (running || !prefs.on) return;
      running = true;
      requestAnimationFrame(frame);
    }

    function clamp(v) {
      return v < -1 ? -1 : v > 1 ? 1 : v;
    }

    function dead(v) {
      v = v || 0;
      return Math.abs(v) < DEADZONE ? 0 : v;
    }

    function fade(v) {
      v *= DECAY;
      return Math.abs(v) < 0.001 ? 0 : v;
    }

    function retarget(target) {
      var el = hitFor(target);
      if (el === hovered) return;
      hovered = el;
      if (!el) {
        clearActive();
        return;
      }
      activeBtn = roleFor(el);
      lightFace(activeBtn, true);
    }

    function onMove(e) {
      var now = e.timeStamp || performance.now();
      var dt = lastMoveT ? Math.min(Math.max(now - lastMoveT, 8), 64) : 16;
      var dx = e.clientX - lastMx;
      var dy = e.clientY - lastMy;
      lastMoveT = now;
      lastMx = e.clientX;
      lastMy = e.clientY;
      mx = e.clientX;
      my = e.clientY;

      ltx = ltx * 0.55 + clamp(dx / dt / FAST) * 0.45;
      lty = lty * 0.55 + clamp(dy / dt / FAST) * 0.45;

      retarget(e.target);
      start();
    }

    function onScroll() {
      var sy = window.scrollY || 0;
      var d = sy - lastScrollY;
      lastScrollY = sy;

      if (capR) rty = clamp(rty + d / SCROLL_FULL);
      else lty = clamp(lty + d / SCROLL_FULL);

      retarget(document.elementFromPoint(mx, my));

      start();
    }

    function press(btn) {
      if (!prefs.on) return;
      var face = faces[btn];
      if (face) face.classList.add('is-pressed', 'is-lit');
      if (pressTimer) clearTimeout(pressTimer);
      pressTimer = setTimeout(function () {
        if (face) face.classList.remove('is-pressed');
        lightFace(activeBtn, !!activeBtn);
      }, PRESS_MS);
    }

    function onDown(e) {
      var el = hitFor(e.target);
      if (!el) return;
      press(roleFor(el));
    }

    function onKey(e) {
      if (e.key === 'Escape') press('b');
    }

    function onLeave(e) {
      if (e.relatedTarget || e.toElement) return;
      hovered = null;
      clearActive();
    }

    var wired = false;

    function wire() {
      if (wired) return;
      wired = true;
      document.addEventListener('pointermove', onMove, { passive: true });
      window.addEventListener('scroll', onScroll, { passive: true });
      document.addEventListener('pointerdown', onDown, { passive: true });
      document.addEventListener('keydown', onKey);
      document.addEventListener('mouseout', onLeave);
    }

    function unwire() {
      if (!wired) return;
      wired = false;
      document.removeEventListener('pointermove', onMove);
      window.removeEventListener('scroll', onScroll);
      document.removeEventListener('pointerdown', onDown);
      document.removeEventListener('keydown', onKey);
      document.removeEventListener('mouseout', onLeave);
      clearActive();
      lx = ly = ltx = lty = 0;
      rx = ry = rtx = rty = 0;
      writeSticks();
    }

    function savePrefs() {
      writePrefs({ on: prefs.on, pack: userPack });
    }

    function applyOn() {
      root.classList.toggle('is-off', !prefs.on);
      if (prefs.on) {
        wire();
        start();
      } else {
        unwire();
      }
    }

    function buildPanel() {
      if (docked) {
        packList.innerHTML =
          '<p class="mp-ctl__panel-note">' + PACKS[prefs.pack].label +
          ' — matched to this listing.</p>';
        onSwitch.checked = prefs.on;
        return;
      }

      var html = '';
      Object.keys(PACKS).forEach(function (id) {
        html +=
          '<label class="mp-ctl__opt">' +
          '<input type="radio" name="mp-ctl-pack" value="' + id + '"' +
          (id === prefs.pack ? ' checked' : '') + '>' +
          '<span>' + PACKS[id].label + '</span>' +
          '</label>';
      });
      packList.innerHTML = html;
      onSwitch.checked = prefs.on;
    }

    function openPanel(open) {
      panel.hidden = !open;
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    toggle.addEventListener('click', function () {
      openPanel(panel.hidden);
    });

    panel.addEventListener('change', function (e) {
      if (e.target === onSwitch) {
        prefs.on = onSwitch.checked;
        savePrefs();
        applyOn();
        return;
      }
      if (e.target.name === 'mp-ctl-pack') {
        prefs.pack = e.target.value;
        userPack = e.target.value;
        pack = PACKS[prefs.pack];
        savePrefs();
        applyPack();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !panel.hidden) {
        openPanel(false);
        toggle.focus();
      }
    });

    document.addEventListener('pointerdown', function (e) {
      if (panel.hidden) return;
      if (panel.contains(e.target) || toggle.contains(e.target)) return;
      openPanel(false);
    });

    window.addEventListener('gamepadconnected', function () {
      padCount++;
      root.classList.add('has-gamepad');
      start();
    });

    window.addEventListener('gamepaddisconnected', function () {
      padCount = Math.max(0, padCount - 1);
      if (!padCount) {
        root.classList.remove('has-gamepad');
        gamepadLit = { a: false, b: false, x: false, y: false };
        lightFace(activeBtn, !!activeBtn);
      }
    });

    if (docked && dockNeighbour) {
      var resizeQueued = false;
      window.addEventListener('resize', function () {
        if (resizeQueued) return;
        resizeQueued = true;
        requestAnimationFrame(function () {
          resizeQueued = false;
          syncDockSize();
        });
      }, { passive: true });

      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(syncDockSize);
      }
    }

    applyPack();
    syncDockSize();
    buildPanel();
    root.classList.add('is-live');
    applyOn();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
